module.exports = __webpack_public_path__ + "img/hp-three-2.7718eec8.jpg";